import styled from 'styled-components';

export const Row = styled.div`
  display: flex;
  align-items: center;
  padding: 1px 0;
  font-size: 15px;
  color: #616161;
`;
